var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "self-stretch flex flex-col",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.$emit("submit", _vm.authenticationMethod)
        }
      }
    },
    [
      _c("input", {
        ref: "login-url-input",
        staticClass:
          "\n            flex-grow shadow p-2 rounded-lg border border-gray-300\n            focus:border-primary-500\n        ",
        attrs: { placeholder: "Solid POD url" },
        domProps: { value: _vm.loginUrl },
        on: {
          input: function($event) {
            return _vm.$emit("updateLoginUrl", $event.target.value)
          }
        }
      }),
      _vm.authenticationMethod
        ? _c("div", [
            _c(
              "label",
              {
                staticClass: "sr-only",
                attrs: { for: "authentication-method" }
              },
              [_vm._v("Authentication method")]
            ),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.authenticationMethod,
                    expression: "authenticationMethod"
                  }
                ],
                ref: "authentication-method-select",
                staticClass:
                  "\n                w-full p-2 mt-4 truncate bg-white border border-gray-300 rounded-md shadow-sm\n                focus:border-primary-500\n            ",
                attrs: { id: "authentication-method" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.authenticationMethod = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              _vm._l(_vm.authenticationMethods, function(method) {
                return _c(
                  "option",
                  { key: method, domProps: { value: method } },
                  [
                    _vm._v(
                      " Log in using " +
                        _vm._s(_vm.authenticationMethodNames[method]) +
                        " "
                    )
                  ]
                )
              }),
              0
            ),
            _c(
              "p",
              { staticClass: "text-sm text-gray-700 mt-1 leading-relaxed" },
              [
                _vm._v(" " + _vm._s(_vm.authenticationMethodDescription) + " "),
                _c(
                  "a",
                  {
                    staticClass: "text-gray-700 underline hover:text-gray-800",
                    attrs: {
                      href: _vm.authenticationMethodUrl,
                      target: "_blank"
                    }
                  },
                  [_vm._v(" Learn more ")]
                )
              ]
            ),
            _c("div", { staticClass: "h-2" })
          ])
        : _vm._e(),
      _c(
        "BaseButton",
        {
          staticClass:
            "\n            bg-brand-solid-500 h-10 shadow text-white mt-4\n            text-sm justify-center font-medium tracking-wide hover:bg-brand-solid-700\n        ",
          attrs: { submit: "", icon: "solid-emblem" }
        },
        [_vm._v(" Log in with Solid ")]
      ),
      !_vm.authenticationMethod
        ? _c(
            "BaseLink",
            {
              staticClass: "text-sm self-center mt-4 leading-normal",
              on: { click: _vm.showAuthenticationMethods }
            },
            [
              _vm._v(
                " Can't log in? try using a different authentication method "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }